module.exports = __webpack_public_path__ + "static/media/urbangoo01.fa5ab5e2.webp";